export * from "./template-interpolatables.component";
